import type { Component } from 'solid-js'
import type { VideosTimeSeriesData } from '../../../features/engagement/domain/models/videos'
import { ChartContainer, ChartLegend, useChartWithLegend, useLegendState } from '../charts'
import {
  getVideosChartOptions,
  VIDEOS_LEGEND_ITEMS,
  VIDEOS_INITIAL_LEGEND_STATE,
  type VideosLegendState
} from './VideosChart.vm'

interface VideosChartProps {
  data: VideosTimeSeriesData[]
  showTimesViewed?: boolean
  showUniqueViewers?: boolean
}

const VideosChart: Component<VideosChartProps> = (props) => {
  let chartRef: HTMLDivElement | undefined

  const initialState: VideosLegendState = {
    timesViewed: props.showTimesViewed ?? VIDEOS_INITIAL_LEGEND_STATE.timesViewed,
    uniqueViewers: props.showUniqueViewers ?? VIDEOS_INITIAL_LEGEND_STATE.uniqueViewers
  }

  const { state: legendState, toggle } = useLegendState(initialState)

  useChartWithLegend({
    data: () => props.data,
    chartRef: () => chartRef,
    legendState,
    buildOptions: (data, legend) => getVideosChartOptions(data, legend)
  })

  return (
    <ChartContainer hasData={props.data && props.data.length > 0}>
      <ChartLegend items={VIDEOS_LEGEND_ITEMS} activeKeys={legendState()} onToggle={toggle} class="mb-4" />
      <div ref={chartRef} />
    </ChartContainer>
  )
}

export default VideosChart
